export default "__VITE_ASSET__CaoNHROn__"